export const LOGIN_ERRORS = {
  STATE: ['no matching state', 'invalid state', 'state mismatch'],
  ACCESS: ['user_cancelled', 'access_denied'],
};
